// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD_F6TRttuCFbKlHfOK5neXEhM-MhWMEaU",
  authDomain: "new-football-boots.firebaseapp.com",
  projectId: "new-football-boots",
  storageBucket: "new-football-boots.appspot.com",
  messagingSenderId: "253365278831",
  appId: "1:253365278831:web:937cf75d50a5f433e6159a",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const fireStrore = getFirestore(app);
